import Vue from 'vue'
import store from '@/store'
import insane, { defaults as insaneDefaults } from 'insane'
import marked from 'marked'

const cache = {}

function getAttachmentUrl (id) {
  const applicationId = store.getters['contextStore/applicationId']
  const trackerTypeId = store.getters['contextStore/trackerTypeId']
  const trackerId = store.getters['contextStore/trackerId']
  const url = Vue.axios.agilisUrlTrackerAttachmentsEdit(
    applicationId,
    trackerTypeId,
    trackerId,
    id)

  return url
}

const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi

const ON_ERROR_RELOAD_WITH_AUTH = 'window.loadImagesSrc(this)'

export function sanitize (dirty) {
  return insane(dirty, {
    allowedAttributes: {
      span: ['class'],
      img: ['src', 'alt', 'class', 'data-src', 'onerror']
    },
    allowedSchemes: [...insaneDefaults.allowedSchemes, 'blob'],
    filter (token) {
      if (token.tag === 'img' && token.attrs.onerror) {
        return token.attrs.onerror === ON_ERROR_RELOAD_WITH_AUTH
      }
      return true
    }
  })
}

export const renderer = {
  image: (id, title, text) => {
    const isUUID = new RegExp(regexExp)
    if (isUUID.test(id)) {
      if (cache[id]) {
        return `<img
        src="${cache[id]}"
        alt="${text}"
        >
        </img>`
      } else {
        return `<img
          class="d-none"
          data-src="${id}"
          src="error-src"
          alt="${text}"
          onerror="${ON_ERROR_RELOAD_WITH_AUTH}"
        >
        </img>`
      }
    }

    return `<img
      src="${id}"
      alt="${text}"
    >
    </img>`
  }
}

const getBlobUrl = async (url) => {
  const requestConfig = Vue.axios.agilisRequestConfig(url)
  requestConfig.responseType = 'blob'
  try {
    const res = await Vue.axios.get(url, requestConfig)
    const blob = new Blob([res.data])
    return URL.createObjectURL(blob)
  } catch (error) {
    throw new Error(`Error loading ${url}`)
  }
}

export async function loadImagesSrc (img) {
  try {
    const url = getAttachmentUrl(img)
    const blobUrl = await getBlobUrl(url)
    cache[img] = blobUrl
    return blobUrl
  } catch (error) {
    throw new Error(error)
  }
}

export function previewRender (text) {
  marked.use({ renderer })
  const dirty = marked(text, {
    highlight: function (code) {
      return window.hljs.highlightAuto(code).value
    },
    breaks: true
  })
  return sanitize(dirty)
}
